import json from "../json/types.json";

export default async () => JSON.parse(JSON.stringify(await json));
